import React from "react";

export default props => (
<div className="instruction-header">
    <div className="instruction-header-col-1">
        <h1>Instructions<br/>&amp;&nbsp;Practice</h1>
    </div>
    <div className="instruction-header-col-2">
        {renderItems(props.content.elems)}
    </div>
</div>
);

function renderItems(elems) {
    return elems.map(function (elem, index) {
        return renderItem(elem, index);
    });
}

function renderItem(elem, index) {
    switch (elem.type) {
    case "p":
        return <p key={index}>{elem.text}</p>;
    default:
        return null;
    }
}
